import React, { Component } from 'react';

/**
* Class Unauthorized
* Unauthorized component
**/
class Unauthorized extends Component {

  /**
  * componentWillMount
  * TODO : Load HTML from here
  **/
  componentWillMount() {}

  /**
  * render
  * Rendering component function : display the unauthorized page
  **/
  render() {
    return(
      <div className="Unauthorized">
        <h2>Requête non autorisée</h2>

        <div style={{margin: "50px"}}>
          <center><p>Vous ne disposez pas des droits nécessaires pour afficher cette page.</p></center>
        </div>
      </div>
    );
  }
}

export default Unauthorized;



// WEBPACK FOOTER //
// ./src/views/Permissions/Unauthorized.js